import { useEffect } from "react";
import {
  BrowserRouter,
  Navigate,
  Outlet,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";
import { useAuth } from "../context/auth";
import Not404Page from "../pages/default/404";
import CondominiosCadastrosPrivatePage from "../pages/private/condominios/cadastros";
import CondominiosCertificadosPrivatePage from "../pages/private/condominios/certificados";
import HomePrivatePage from "../pages/private/home";
import LancamentosNotasNFSEPrivatePage from "../pages/private/notas_fiscais/lancamentos/servicos";
import ConfirmUserPage from "../pages/public/confirm_user";
import ContactPage from "../pages/public/contact";
import CreateUserPage from "../pages/public/create_user";
import HomePage from "../pages/public/home";
import AboutPage from "../pages/public/login";
import ResetPasswordUserPage from "../pages/public/password_user";
import { checkAuth } from "../utils/authFuncs";
import RoutesConfigs from "./configs";
import RoutesReports from "./reports";

const Router = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<PublicRoutesBase />}>
          <Route index path="/" element={<HomePage />} />
          <Route path="/login" element={<AboutPage />} />
          <Route path="/criar-usuario" element={<CreateUserPage />} />
          <Route path="/confirmar-usuario" element={<ConfirmUserPage />} />
          <Route path="/recuperar-senha" element={<ResetPasswordUserPage />} />
          <Route path="/contato" element={<ContactPage />} />
        </Route>

        <Route element={<PrivateRoutesBase />}>
          <Route index path="/home" element={<HomePrivatePage />} />

          <Route
            path="/notas-fiscais/lancamentos/servico"
            element={<LancamentosNotasNFSEPrivatePage />}
          />
          <Route
            path="/condominios/cadastros"
            element={<CondominiosCadastrosPrivatePage />}
          />
          <Route
            path="/condominios/certificados"
            element={<CondominiosCertificadosPrivatePage />}
          />

          {RoutesReports()}
          {RoutesConfigs()}
        </Route>

        <Route path="*" element={<Not404Page />} />
        <Route path="/logout" element={<LogoutComponent />} />
      </Routes>
    </BrowserRouter>
  );
};

const PublicRoutesBase = () => {
  return checkAuth() ? <Navigate to="/home" /> : <Outlet />;
};

const PrivateRoutesBase = () => {
  return checkAuth() ? <Outlet /> : <Navigate to="/" />;
};

export const LogoutComponent = () => {
  const { logout } = useAuth();
  const location = useLocation();

  useEffect(() => {
    logout();
  }, [logout]);

  return <Navigate to="/" state={{ from: location }} replace />;
};

export default Router;
